import { render, staticRenderFns } from "./SectionDetailsButtons.vue?vue&type=template&id=7d70b69d&scoped=true"
import script from "./SectionDetailsButtons.vue?vue&type=script&lang=js"
export * from "./SectionDetailsButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d70b69d",
  null
  
)

export default component.exports